export default {
  production: false,
  legalQuestionnaireReadOnly: false,
  Okta: {
    issuer: 'https://preview.wcgclinical.com/oauth2/default', // Set from Jenkins credentials: okta_issuer
    baseUrl: 'https://preview.wcgclinical.com', // Set from Jenkins credentials: okta_baseurl
    clientId: '0oah9cuaupKhU8EoU1d7', // Set from Jenkins credentials: okta_clientid
    redirectUri:
      'https://bta-ereviewmanager.wcgclinical.com/auth/login/callback', // Set from Jenkins credentials: okta_redirecturi
    disableHttpsCheck: true,
    useClassicEngine: false,
    postLogoutRedirectUri: 'https://bta-clinsphere.wcgclinical.com',
  },
  clinsphereUrl: 'https://bta-clinsphere.wcgclinical.com',
  joBaseUrl: 'https://bta-ereviewmanager.wcgclinical.com/submitassist',
  // Must match ai-irb's IDP_ENVIRONMENT.
  oktaGroupEnv: 'BTA',
  irisApi: 'https://bta-be-ereviewmanager.wcgclinical.com',
  jemmaApi: 'https://bta-clinsphere.wcgclinical.com/jemma/',
  jemmaEventSource: '7f90a79ddce16dd9350fabd4b2370744',
  workspaceNewVersion: true,
  enabledTask: false,
  irisWS: 'wss://bta-be-ereviewmanager.wcgclinical.com/ws',
  appBaseHref: 'https://bta-ereviewmanager.wcgclinical.com',
  oneTrustDomainScript: '01958610-261b-786b-a057-5a5fcacdb413',
  newRelic: {
    enabled: true,
    accountID: '211490',
    trustKey: '211490',
    agentID: '1103450719',
    licenseKey: 'NRBR-4310019effceddf7e30',
    applicationID: '1103450719',
  },
  maxSessionLength: 24 * 60 * 60 * 1000,
  sessionTimeout: 58 * 60 * 1000,
  sessionGracePeriod: 2 * 60 * 1000,
  checkForOneTrustConsent: true,
  walkMeUrl:
    'https://cdn.walkme.com/users/ee75fa9a9e0e4c46bfdcf49e30de33b9/beta/walkme_ee75fa9a9e0e4c46bfdcf49e30de33b9_https.js',
  talkdesk: {
    accountId: '',
    region: 'td-us-1',
    touchpointId: '3828156e6f634b75a2525c108570d383',
    scriptUrl: 'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js',
    config: {
      enableValidation: true,
      enableEmoji: true,
      enableAttachments: true,
      showInitialScreen: true,
      chatTitle: 'Live chat',
      initialScreenSubmitButtonLabel: 'Start Chat',
      website_url: 'https://bta-ereviewmanager.wcgclinical.com',
    },
  },
  enableReviewerMaterials: true,
  showDashboardConfigPanel: false,
};
